
/***** State Function *************** */
// For CSRF protection
var generateState = function(state = "") {
    return crypto.randomUUID()+"-"+state;
};


/******* Nonce Function************** */
// For replay attack prevention
var generateNonce = function(length = 32) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array); // Generate cryptographically secure random values
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

var generateNonceBase64 =  function(length = 32) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return btoa(String.fromCharCode(...array))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // Base64 URL-safe
};

exports.generateNonce = generateNonce;
exports.generateNonceBase64 = generateNonceBase64;
exports.generateState = generateState;

/********* DPoP Keys ***************** */
var exportDPoPKeyPair = async function exportDPoPKeyPair(keyPair) {
    const publicKeyJwk = await window.crypto.subtle.exportKey("jwk", keyPair.publicKey);
    const privateKeyJwk = await window.crypto.subtle.exportKey("jwk", keyPair.privateKey);

    return { publicKeyJwk, privateKeyJwk };
}

exports.exportDPoPKeyPair = exportDPoPKeyPair;

var storeKeyPairInSessionStorageForDPoP = async function(keyPair) {
    var dPoPKeyPair = await exportDPoPKeyPair(keyPair);
    await storeDPoPKeyPairInSessionStorage(dPoPKeyPair);
}

exports.storeKeyPairInSessionStorageForDPoP = storeKeyPairInSessionStorageForDPoP;

var storeDPoPKeyPairInSessionStorage = async function(dPoPKeyPair) {
    sessionStorage.setItem("DPoP_Public_Key", JSON.stringify(dPoPKeyPair.publicKeyJwk));
    sessionStorage.setItem("DPoP_Private_Key", JSON.stringify(dPoPKeyPair.privateKeyJwk));
};

exports.storeDPoPKeyPairInSessionStorage = storeDPoPKeyPairInSessionStorage;

exports.retrieveJSONPublicKeyFromSessionStorage = function () {
    const publicKeyJwk = sessionStorage.getItem("DPoP_Public_Key");

    return {
        "keyType": "public",
        "format": "json",
        "key": publicKeyJwk,
        "algo": { name: "ECDSA", namedCurve: "P-256" }, // Algorithm must match the original
        "extractable": true, // Whether the key is extractable
        "usages": ["verify"], // Usage for public key
        "remarks": "parse key as JSON"
    }
};

var retrieveDPoPKeyPairFromSessionStorage = async function () {
    const publicKeyJwk = JSON.parse(sessionStorage.getItem("DPoP_Public_Key"));
    const privateKeyJwk = JSON.parse(sessionStorage.getItem("DPoP_Private_Key"));

    const publicKey = await window.crypto.subtle.importKey(
        "jwk",
        publicKeyJwk,
        { name: "ECDSA", namedCurve: "P-256" }, // Algorithm must match the original
        true, // Whether the key is extractable
        ["verify"] // Usage for public key
    );

    const privateKey = await window.crypto.subtle.importKey(
        "jwk",
        privateKeyJwk,
        { name: "ECDSA", namedCurve: "P-256" }, // Algorithm must match the original
        true, // Whether the key is extractable
        ["sign"] // Usage for private key
    );

    return { publicKey, privateKey };
};

exports.retrieveDPoPKeyPairFromSessionStorage = retrieveDPoPKeyPairFromSessionStorage;
